import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';
import { OFFER_SETTINGS_FRAGMENT } from 'graphql/fragments/offer-settings';
import { OFFER_TEMPLATE_SETTINGS_FRAGMENT } from 'graphql/fragments/offer-template-settings';

export const BRANCH_FRAGMENT = gql`
  fragment BranchFragment on Branch {
    id
    name
    name2
    address {
      ...AddressFragment
    }
    executives
    districtCourt
    hrb
    bank
    iban
    ustNr
    taxNr
    offerSettings {
      ...OfferSettingsFragment
    }
    offerTemplateSettings {
      ...OfferTemplateSettingsFragment
    }
  }
  ${ADDRESS_FRAGMENT}
  ${OFFER_SETTINGS_FRAGMENT}
  ${OFFER_TEMPLATE_SETTINGS_FRAGMENT}
`;

export const BRANCH_OFFER_SETTINGS_FRAGMENT = gql`
  fragment BranchOfferSettingsFragment on Branch {
    offerSettings {
      ...OfferSettingsFragment
    }
  }
  ${OFFER_SETTINGS_FRAGMENT}
`;

export const BRANCH_OFFER_TEMPLATE_SETTINGS_FRAGMENT = gql`
  fragment BranchOfferTemplateSettingsFragment on Branch {
    offerTemplateSettings {
      ...OfferTemplateSettingsFragment
    }
  }
  ${OFFER_TEMPLATE_SETTINGS_FRAGMENT}
`;
